import { InjectionToken, Provider, Type } from '@angular/core';
import { DataService, ScrollService } from 'lu-services';
import { LuSelectCustomItem } from './lu-select-items/lu-select-custom-item';
import { LuSelectItemBasicOptions } from './lu-select-items/lu-select-item-basic/lu-select-item-basic.component';
import { LuSelectItemImageOptions } from './lu-select-items/lu-select-item-image/lu-select-item-image.component';

export const dataService = new InjectionToken<DataService>('dataService');
export const scrollService = new InjectionToken<ScrollService>('scrollService');

export interface LuSelectModuleConfig {
	dataService?: Provider;
	scrollService?: Provider;
}

export interface LuSelectOptions {
	itemOptions: LuSelectCustomItemOptions | LuSelectItemBasicOptions | LuSelectItemImageOptions;
	paginate?: boolean;
	disabled?: boolean;
	readonly?: boolean;
	placeholder?: string;
	selectAs?: string;
	groupBy?: string;
	id?: string;
	filterBy?: string;
	showSearch?: boolean;
	customExclude?: boolean; // we want to pass exclude as custom through url options params
	noDataFound?: string;
	displayClearButton?: boolean;
}

export interface LuSelectUrlOptions {
	apiUrl?: string;
	params?: {
		[name: string]: string | string[] | boolean | boolean[] | number | number[];
	};
}

export abstract class LuSelectBaseOptions {
	abstract type: LuSelectType;
}

export interface ILuSelectCustomItem {
	dummy?: string;
}

export class LuSelectCustomItemOptions {
	itemComponent: Type<LuSelectCustomItem<ILuSelectCustomItem>>;
	interface: ILuSelectCustomItem;
	type: LuSelectType.CUSTOM;
}

export declare type LuSelectFormatter = (dataContext: any, value: any) => string;

export enum LuSelectType {
	BASIC = 'basic',
	IMAGE = 'image',
	CUSTOM = 'custom'
}
